export default {
  toolBox: [
    'Comparison',
    'Arithmetic',
    'Constant',
    'Logic',
    'Boolean',
    'Counter',
    'Random',
    'Timer',
    'Terminal',
  ],
  gadgets: ['Infrared', 'LightSensor', 'Ultrasound', 'HallSensor', 'SoilMoisture', 'MicroSwitch'],
  nodeInputCountMap: {
    Logic: {
      AND: [2, 8],
      OR: [2, 8],
      NAND: [2, 8],
      NOR: [2, 8],
      XOR: [2, 2],
      NOT: [1, 1],
    },
    Arithmetic: {
      Addition: [2, 8],
      Subtraction: [2, 8],
      Multiplication: [2, 8],
      Division: [2, 2],
      Modulo: [2, 2],
      Power: [2, 2],
    },
    Comparison: {
      Equality: [2, 2],
      Greater: [2, 2],
      GreaterEqual: [2, 2],
      Inequality: [2, 2],
      Less: [2, 2],
      LessEqual: [2, 2],
    },
    Boolean: {
      True: [0, 0],
      False: [0, 0],
    },
    Constant: {
      special: [0, 0],
    },
    Random: {
      special: [2, 2],
    },
    Timer: {
      special: [1, 1],
    },
    Terminal: {
      special: [1, 1],
    },
    Counter: {
      CounterUp: [3, 3],
      CounterDown: [3, 3],
    },
    Gadgets: {
      Infrared: [1, 1],
      Ultrasound: [1, 1],
      LightSensor: [1, 1],
      MicroSwitch: [1, 1],
      SoilMoisture: [1, 1],
      HallSensor: [1, 1],
      VariableBoard: [1, 1],
      JoystickButton: [1, 1],
      JoystickAnalog: [1, 1],
    },
    AIModels: {
      special: [1, 1],
    },
  },
  nodeTemplates: {
    Logic: {
      type: 'Logic',
      label: '邏輯',

      styleClass: {
        firstClass: 'Logic',
        secondClass: 'AND',
      },
      portStyle: {
        input: [
          [0, 0],
          [0, 0],
        ],
        output: [[0, 0]],
      },
      properties: {
        compareType: 'AND',
        value: 0,
        inputCount: 2,
        outputCount: 1,
        inputs: {
          input1: 0,
          input2: 0,
        },
        outputs: {
          output1: 0,
        },
      },
    },
    Arithmetic: {
      type: 'Arithmetic',
      label: '運算',

      styleClass: {
        firstClass: 'Arithmetic',
        secondClass: 'Addition',
      },
      portStyle: {
        input: [
          [0, 0],
          [0, 0],
        ],
        output: [[0, 0]],
      },
      properties: {
        compareType: 'Addition',
        value: 0,
        inputCount: 2,
        outputCount: 1,
        inputs: {
          input1: 0,
          input2: 0,
        },
        outputs: {
          output1: 0,
        },
      },
    },
    Comparison: {
      type: 'Comparison',
      label: '比較',

      styleClass: {
        firstClass: 'Comparison',
        secondClass: 'Equality',
      },
      portStyle: {
        input: [
          [0, 0],
          [0, 0],
        ],
        output: [[0, 0]],
      },
      properties: {
        compareType: 'Equality',
        value: 0,
        inputCount: 2,
        outputCount: 1,
        inputs: {
          input1: 0,
          input2: 0,
        },
        outputs: {
          output1: 0,
        },
      },
    },
    Boolean: {
      type: 'Boolean',
      label: '布林',

      styleClass: {
        firstClass: 'Boolean',
        secondClass: 'True',
      },
      portStyle: {
        input: [],
        output: [[0, 0]],
      },
      properties: {
        value: 1,
        inputCount: 0,
        outputCount: 1,
        inputs: {},
        outputs: {
          output1: 0,
        },
      },
    },
    Constant: {
      type: 'Constant',
      label: '常數0',

      styleClass: {
        firstClass: 'Constant',
        secondClass: 'special',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 0,
        outputCount: 1,
        inputs: {},
        outputs: {
          output1: 0,
        },
      },
    },
    Random: {
      type: 'Random',
      label: '隨機',

      styleClass: {
        firstClass: 'Random',
        secondClass: 'special',
      },
      portStyle: {
        input: [
          [0, 0],
          [0, 0],
        ],
        output: [[0, 0]],
      },
      properties: {
        value: 1,
        inputCount: 2,
        outputCount: 1,
        inputs: {
          input1: 0,
          input2: 0,
        },
        outputs: {
          output1: 0,
        },
      },
      toolTips: {
        input1: 'Maximum',
        input2: 'Minimum',
        output1: 'Random value',
      },
    },
    Timer: {
      type: 'Timer',
      label: '計時器',

      styleClass: {
        firstClass: 'Timer',
        secondClass: 'special',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 1,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
      },
      toolTips: {
        input1: 'Reset',
        output1: 'time(ms)',
      },
    },
    Counter: {
      type: 'Counter',
      label: '計數器',

      styleClass: {
        firstClass: 'Counter',
        secondClass: 'CounterUp',
      },
      portStyle: {
        input: [
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 3,
        outputCount: 1,
        inputs: {
          input1: 0,
          input2: 0,
          input3: 0,
        },
        outputs: {
          output1: 0,
        },
      },
      toolTips: {
        input1: 'Count button',
        input2: 'Default Value',
        input3: 'Reset',
        output1: 'Count',
      },
    },
    Infrared: {
      type: 'Gadgets',
      label: '小工具 紅外線',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'Infrared',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'Infrared',
          port: 'Port 1',
          sensor: 'Sensor 1',
          ble: {},
        },
      },
    },
    Ultrasound: {
      type: 'Gadgets',
      label: '小工具 超音波',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'Ultrasound',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'Ultrasound',
          port: 'Port 3',
          ble: {},
        },
      },
    },
    LightSensor: {
      type: 'Gadgets',
      label: 'LightSensor',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'LightSensor',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'LightSensor',
          port: 'Port 1',
          ble: {},
        },
      },
    },
    MicroSwitch: {
      type: 'Gadgets',
      label: 'MicroSwitch',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'MicroSwitch',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'MicroSwitch',
          port: 'Port 1',
          ble: {},
        },
      },
    },
    SoilMoisture: {
      type: 'Gadgets',
      label: 'SoilMoisture',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'SoilMoisture',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'SoilMoisture',
          port: 'Port 1',
          ble: {},
        },
      },
    },
    HallSensor: {
      type: 'Gadgets',
      label: 'HallSensor',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'HallSensor',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'HallSensor',
          port: 'Port 1',
          ble: {},
        },
      },
    },
    VariableBoard: {
      type: 'Gadgets',
      label: 'VariableBoard',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'VariableBoard',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'VariableBoard',
          port: 'Port 4',
          controlDial: 1,
          ble: {},
        },
      },
    },
    JoystickButton: {
      type: 'Gadgets',
      label: 'JoystickButton',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'JoystickButton',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'JoystickButton',
          button: 1,
          ble: {},
        },
      },
    },
    JoystickAnalog: {
      type: 'Gadgets',
      label: 'JoystickAnalog',

      styleClass: {
        firstClass: 'Gadgets',
        secondClass: 'JoystickAnalog',
      },
      portStyle: {
        input: [[0, 0]],
        output: [[0, 0]],
      },
      properties: {
        value: 0,
        inputCount: 1,
        outputCount: 1,
        inputs: {
          input1: 0,
        },
        outputs: {
          output1: 0,
        },
        gadgetsProp: {
          type: 'JoystickAnalog',
          value: 'X',
          ble: {},
        },
      },
    },
    Terminal: {
      type: 'Terminal',
      label: '終點',

      styleClass: {
        firstClass: 'Terminal',
        secondClass: 'special',
      },
      portStyle: {
        input: [[0, 0]],
        output: [],
      },
      properties: {
        value: 1,
        inputCount: 1,
        outputCount: 0,
        inputs: {
          input1: 0,
        },
        outputs: {},
      },
      toolTips: {
        input1: 'Connect and stop',
      },
    },
    AIModels: {},
    Actions: {},
  },
};
